// import React, { useState } from 'react';
// import { Button, CssBaseline, TextField, Paper, Box, Grid, Typography, CircularProgress } from '@mui/material';
// import { createTheme, ThemeProvider } from '@mui/material/styles';
// import { useNavigate } from 'react-router-dom';
// import { useForm } from 'react-hook-form';
// import FormHelperText from '@mui/material/FormHelperText';
// import loginService from '../../services/login.Service';
// import LoginImg from '../../images/admin_image.jpeg';
// import tri_gases from '../../images/tri_gases.jpeg';
// import styles from '../../styles.module.css';

// const theme = createTheme();

// const CYLTrackingLogin = () => {
//   const { handleSubmit } = useForm({});
//   const navigate = useNavigate();
//   const [userName, setUserName] = useState('');
//   const [loginPassword, setLoginPassword] = useState('');
//   const [error, setError] = useState(false);
//   const [helperText, setHelperText] = useState('');
//   const [loading, setLoading] = useState(false);

//   const handleUsername = (e) => {
//     setUserName(e.target.value);
//     setError(false);
//     setHelperText('');
//   };

//   const handlePassword = (e) => {
//     setLoginPassword(e.target.value);
//     setError(false);
//     setHelperText('');
//   };

// const onSubmit = async () => {
//   if (!userName || !loginPassword) {
//     setHelperText('Please enter both username and password');
//     setError(true);
//     return;
//   }

//   setLoading(true);
//   setHelperText('');

//   try {
//     const response = await loginService.login({ userName, loginPassword });

//     if (response.message === 'User found and login successful') {
//       // Store all login data in sessionStorage
//       sessionStorage.setItem('authToken', response.result.authToken);
//       sessionStorage.setItem('loginUser', JSON.stringify(response));

//       navigate('/dashboard');
//     } else {
//       setHelperText(response.message || 'Login failed');
//       setError(true);
//     }
//   } catch (err) {
//     setHelperText(err.message || 'An error occurred');
//     setError(true);
//   } finally {
//     setLoading(false);
//   }
// };



//   return (
//     <ThemeProvider theme={theme}>
//       <Grid container component="main" sx={{ height: '100vh', flexDirection: { xs: 'column', md: 'row' } }}>
//         <CssBaseline />
//         <Grid
//           item
//           xs={12}
//           md={8}
//           sx={{
//             display: { xs: 'none', md: 'flex' },
//             alignItems: 'center',
//             backgroundImage: `url(${LoginImg})`,
//             backgroundRepeat: 'no-repeat',
//             backgroundSize: 'cover',
//             backgroundPosition: 'center',
//             minHeight: { xs: '30vh', md: '100vh' },
//           }}
//         />
//         <Grid
//           item
//           xs={12}
//           md={4}
//           component={Paper}
//           elevation={6}
//           sx={{
//             display: 'flex',
//             alignItems: 'center',
//             justifyContent: 'center',
//             minHeight: { xs: '70vh', md: '100vh' },
//             padding: { xs: 2, sm: 4 },
//           }}
//         >
//           <Box
//             className={`${styles.login_logo_container}`}
//             sx={{
//               display: 'flex',
//               flexDirection: 'column',
//               alignItems: 'center',
//               width: '100%',
//               maxWidth: 400,
//               mx: 'auto',
//               py: { xs: 4, sm: 8 },
//             }}
//           >
//             <Box className={`${styles.login_logo_container}`}>
//               <img src={tri_gases} className={`${styles.login_logo}`} alt="Tri Gases Logo" />
//             </Box>
//             <Typography variant="h4" sx={{ textAlign: 'center' }}>
//               Sign In
//             </Typography>
//             <form onSubmit={handleSubmit(onSubmit)} style={{ width: '100%' }}>
//               <FormHelperText sx={{ color: 'red', fontSize: '15px', textAlign: 'center' }}>
//                 {helperText}
//               </FormHelperText>
//               <TextField
//                 margin="normal"
//                 required
//                 fullWidth
//                 label="Username or Phone Number"
//                 type="text"
//                 id="userName"
//                 name="userName"
//                 value={userName}
//                 onChange={handleUsername}
//                 error={error}
//                 size="small"
//               />
//               <TextField
//                 margin="normal"
//                 required
//                 fullWidth
//                 label="Password"
//                 id="loginPassword"
//                 name="loginPassword"
//                 type="password"
//                 value={loginPassword}
//                 onChange={handlePassword}
//                 error={error}
//                 size="small"
//               />
//               <Button
//                 type="submit"
//                 fullWidth
//                 variant="contained"
//                 sx={{
//                   mt: 3,
//                   mb: 2,
//                   background: '#002b65',
//                   color: 'white',
//                   borderRadius: '10px',
//                   fontSize: '16px',
//                   '&:hover': { background: '#004080' },
//                 }}
//                 disabled={loading}
//               >
//                 {loading ? <CircularProgress size={24} color="inherit" /> : <b>Sign In</b>}
//               </Button>
//             </form>
//           </Box>
//         </Grid>
//       </Grid>
//     </ThemeProvider>
//   );
// };

// export default CYLTrackingLogin;


import React, { useState } from 'react';
import { CircularProgress } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import loginService from '../../services/login.Service';
import tri_gases from '../../images/tri_gases.jpeg';

const CYLTrackingLogin = () => {
  const { handleSubmit } = useForm({});
  const navigate = useNavigate();
  const [userName, setUserName] = useState('');
  const [loginPassword, setLoginPassword] = useState('');
  const [error, setError] = useState(false);
  const [helperText, setHelperText] = useState('');
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const handleUsername = (e) => { setUserName(e.target.value); setError(false); setHelperText(''); };
  const handlePassword = (e) => { setLoginPassword(e.target.value); setError(false); setHelperText(''); };

  const onSubmit = async () => {
    if (!userName || !loginPassword) { setHelperText('Please enter both username and password'); setError(true); return; }
    setLoading(true); setHelperText('');
    try {
      const response = await loginService.login({ userName, loginPassword });
      if (response.message === 'User found and login successful') {
        sessionStorage.setItem('authToken', response.result.authToken);
        sessionStorage.setItem('loginUser', JSON.stringify(response));
        navigate('/dashboard');
      } else { setHelperText(response.message || 'Login failed'); setError(true); }
    } catch (err) { setHelperText(err.message || 'An error occurred'); setError(true); }
    finally { setLoading(false); }
  };

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700&family=Raleway:wght@700;800&display=swap');
        * { box-sizing: border-box; margin: 0; padding: 0; }
        .cyl-login-root { min-height: 100vh; display: flex; font-family: 'Poppins', sans-serif; background: #f0f4f8; }
        .cyl-left {
          flex: 1;
          background: linear-gradient(145deg, #0d3b3b 0%, #0e5252 35%, #0f7070 65%, #148f8f 100%);
          display: flex; flex-direction: column; align-items: center; justify-content: center;
          position: relative; overflow: hidden; padding: 60px 40px;
        }
        .cyl-left::before { content:''; position:absolute; top:-120px; right:-120px; width:420px; height:420px; border-radius:50%; background:rgba(255,255,255,0.04); pointer-events:none; }
        .cyl-left::after  { content:''; position:absolute; bottom:-80px; left:-80px; width:320px; height:320px; border-radius:50%; background:rgba(255,255,255,0.05); pointer-events:none; }
        .cyl-dots { position:absolute; top:40px; right:40px; display:grid; grid-template-columns:repeat(6,10px); gap:8px; opacity:0.18; }
        .cyl-dots span { width:6px; height:6px; border-radius:50%; background:#fff; display:block; }
        .cyl-dots2 { position:absolute; bottom:60px; left:40px; display:grid; grid-template-columns:repeat(4,10px); gap:8px; opacity:0.1; }
        .cyl-dots2 span { width:6px; height:6px; border-radius:50%; background:#fff; display:block; }
        .cyl-left-logo { width:190px; filter:brightness(0) invert(1); margin-bottom:36px; animation:fadeUp 0.8s ease both; }
        .cyl-left-title { font-family:'Raleway',sans-serif; font-size:2.4rem; font-weight:800; color:#fff; text-align:center; line-height:1.25; animation:fadeUp 0.9s ease 0.1s both; }
        .cyl-left-title span { color:#7de8e8; }
        .cyl-left-sub { margin-top:14px; font-size:0.88rem; color:rgba(255,255,255,0.6); text-align:center; max-width:280px; line-height:1.65; animation:fadeUp 1s ease 0.2s both; }
        .cyl-pills { display:flex; flex-direction:column; gap:11px; margin-top:40px; width:100%; max-width:310px; animation:fadeUp 1.1s ease 0.3s both; }
        .cyl-pill { display:flex; align-items:center; gap:12px; background:rgba(255,255,255,0.08); border:1px solid rgba(255,255,255,0.13); border-radius:12px; padding:11px 16px; backdrop-filter:blur(8px); }
        .cyl-pill-ic { width:34px; height:34px; border-radius:8px; background:rgba(125,232,232,0.18); display:flex; align-items:center; justify-content:center; flex-shrink:0; }
        .cyl-pill-ic svg { width:17px; height:17px; }
        .cyl-pill-txt { font-size:0.8rem; color:rgba(255,255,255,0.82); font-weight:500; }

        .cyl-right { width:480px; background:#fff; display:flex; align-items:center; justify-content:center; padding:48px 52px; position:relative; box-shadow:-8px 0 40px rgba(0,0,0,0.08); }
        .cyl-form-inner { width:100%; max-width:360px; animation:fadeIn 0.7s ease both; }
        .cyl-form-logo { width:120px; margin-bottom:28px; display:block; }
        .cyl-heading { font-family:'Raleway',sans-serif; font-size:1.7rem; font-weight:800; color:#0d3b3b; margin-bottom:4px; }
        .cyl-sub { font-size:0.83rem; color:#7a8fa6; margin-bottom:28px; }
        .cyl-divider { width:46px; height:3px; background:linear-gradient(90deg,#0f7070,#7de8e8); border-radius:2px; margin-bottom:26px; }

        .cyl-field { margin-bottom:18px; }
        .cyl-lbl { display:block; font-size:0.75rem; font-weight:600; color:#4a5568; margin-bottom:6px; letter-spacing:0.5px; text-transform:uppercase; }
        .cyl-iw { position:relative; }
        .cyl-ico { position:absolute; left:13px; top:50%; transform:translateY(-50%); color:#94a3b8; display:flex; align-items:center; }
        .cyl-ico svg { width:17px; height:17px; }
        .cyl-inp {
          width:100%; padding:12px 42px 12px 40px;
          border:1.5px solid #e2e8f0; border-radius:10px;
          font-size:0.9rem; font-family:'Poppins',sans-serif; color:#1a202c;
          background:#f8fafc; outline:none;
          transition:border-color 0.2s,box-shadow 0.2s,background 0.2s;
        }
        .cyl-inp:focus { border-color:#0f7070; background:#fff; box-shadow:0 0 0 3px rgba(15,112,112,0.12); }
        .cyl-inp.err { border-color:#e53e3e; box-shadow:0 0 0 3px rgba(229,62,62,0.1); }
        .cyl-eye { position:absolute; right:12px; top:50%; transform:translateY(-50%); background:none; border:none; cursor:pointer; color:#94a3b8; display:flex; align-items:center; padding:4px; border-radius:4px; transition:color 0.2s; }
        .cyl-eye:hover { color:#0f7070; }
        .cyl-eye svg { width:17px; height:17px; }

        .cyl-err-box { font-size:0.79rem; color:#e53e3e; margin-bottom:16px; display:flex; align-items:center; gap:6px; background:#fff5f5; padding:9px 12px; border-radius:8px; border-left:3px solid #e53e3e; }
        .cyl-err-box svg { flex-shrink:0; }

        .cyl-btn {
          width:100%; padding:13px; margin-top:22px;
          background:linear-gradient(135deg,#0d3b3b 0%,#0f7070 100%);
          color:#fff; border:none; border-radius:10px;
          font-size:0.93rem; font-weight:600; font-family:'Poppins',sans-serif;
          cursor:pointer; letter-spacing:0.4px;
          transition:transform 0.15s,box-shadow 0.15s;
          box-shadow:0 4px 16px rgba(15,112,112,0.35);
          display:flex; align-items:center; justify-content:center; gap:8px;
        }
        .cyl-btn:hover:not(:disabled) { transform:translateY(-1px); box-shadow:0 6px 22px rgba(15,112,112,0.45); }
        .cyl-btn:active:not(:disabled) { transform:translateY(0); }
        .cyl-btn:disabled { opacity:0.72; cursor:not-allowed; }

        .cyl-footer { text-align:center; font-size:0.73rem; color:#a0aec0; margin-top:28px; }
        .cyl-footer strong { color:#4a5568; }

        @keyframes fadeUp { from{opacity:0;transform:translateY(20px)} to{opacity:1;transform:translateY(0)} }
        @keyframes fadeIn { from{opacity:0} to{opacity:1} }

        @media (max-width:900px) {
          .cyl-login-root { flex-direction:column; }
          .cyl-left { display:none; }
          .cyl-right { width:100%; min-height:100vh; padding:40px 28px; box-shadow:none; }
        }
      `}</style>

      <div className="cyl-login-root">

        {/* LEFT */}
        <div className="cyl-left">
          <div className="cyl-dots">{Array.from({length:36}).map((_,i)=><span key={i}/>)}</div>
          <div className="cyl-dots2">{Array.from({length:16}).map((_,i)=><span key={i}/>)}</div>

          {/* <img src={tri_gases} className="cyl-left-logo" alt="Tri Gases" /> */}
          <h1 className="cyl-left-title">Cylinder <span>Tracking</span><br/>System</h1>
          <p className="cyl-left-sub">Complete visibility of your cylinder lifecycle — from production to delivery and return.</p>

          <div className="cyl-pills">
            <div className="cyl-pill">
              <div className="cyl-pill-ic">
                <svg viewBox="0 0 24 24" fill="none" stroke="#7de8e8" strokeWidth="2"><path d="M9 17H5a2 2 0 00-2 2v0a2 2 0 002 2h14a2 2 0 002-2v0a2 2 0 00-2-2h-4"/><rect x="9" y="3" width="6" height="14" rx="2"/></svg>
              </div>
              <span className="cyl-pill-txt">Real-time Production & Filling Tracking</span>
            </div>
            <div className="cyl-pill">
              <div className="cyl-pill-ic">
                <svg viewBox="0 0 24 24" fill="none" stroke="#7de8e8" strokeWidth="2"><circle cx="12" cy="12" r="10"/><path d="M12 8v4l3 3"/></svg>
              </div>
              <span className="cyl-pill-txt">Depot-wise Distribution Monitoring</span>
            </div>
            <div className="cyl-pill">
              <div className="cyl-pill-ic">
                <svg viewBox="0 0 24 24" fill="none" stroke="#7de8e8" strokeWidth="2"><path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75"/></svg>
              </div>
              <span className="cyl-pill-txt">Role-based Access for Every Team</span>
            </div>
          </div>
        </div>

        {/* RIGHT */}
        <div className="cyl-right">
          <div className="cyl-form-inner">
            <img src={tri_gases} className="cyl-form-logo" alt="Tri Gases" />
            <h2 className="cyl-heading">Welcome back</h2>
            <p className="cyl-sub">Sign in to your CYL Tracking account</p>
            <div className="cyl-divider"/>

            {helperText && (
              <div className="cyl-err-box">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="15" height="15"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
                {helperText}
              </div>
            )}

            <form onSubmit={(e)=>{e.preventDefault();onSubmit();}}>
              <div className="cyl-field">
                <label className="cyl-lbl">Username</label>
                <div className="cyl-iw">
                  <span className="cyl-ico"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2"/><circle cx="12" cy="7" r="4"/></svg></span>
                  <input className={`cyl-inp${error?' err':''}`} type="text" placeholder="Enter your username" value={userName} onChange={handleUsername} autoComplete="username"/>
                </div>
              </div>

              <div className="cyl-field">
                <label className="cyl-lbl">Password</label>
                <div className="cyl-iw">
                  <span className="cyl-ico"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0110 0v4"/></svg></span>
                  <input className={`cyl-inp${error?' err':''}`} type={showPassword?'text':'password'} placeholder="Enter your password" value={loginPassword} onChange={handlePassword} autoComplete="current-password"/>
                  <button type="button" className="cyl-eye" onClick={()=>setShowPassword(v=>!v)} tabIndex={-1}>
                    {showPassword
                      ? <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M17.94 17.94A10.07 10.07 0 0112 20c-7 0-11-8-11-8a18.45 18.45 0 015.06-5.94M9.9 4.24A9.12 9.12 0 0112 4c7 0 11 8 11 8a18.5 18.5 0 01-2.16 3.19m-6.72-1.07a3 3 0 11-4.24-4.24"/><line x1="1" y1="1" x2="23" y2="23"/></svg>
                      : <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>
                    }
                  </button>
                </div>
              </div>

              <button type="submit" className="cyl-btn" disabled={loading}>
                {loading
                  ? <CircularProgress size={20} sx={{color:'#fff'}}/>
                  : <>Sign In <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" width="16" height="16"><path d="M5 12h14M12 5l7 7-7 7"/></svg></>
                }
              </button>
            </form>

            {/* <p className="cyl-footer"><strong>Tri Gases Pvt. Ltd.</strong> · CYL Tracking System v2.0</p> */}
          </div>
        </div>

      </div>
    </>
  );
};

export default CYLTrackingLogin;


